import { MessageCircle } from 'lucide-react';
import PageHeader from '@/components/PageHeader';

const WHATSAPP_NUMBER = '5521989013039';
const WHATSAPP_MESSAGE = 'Olá! Preciso de ajuda com um presente da Valentina.';

export default function AjudaPage() {
  return (
    <main className="valentina-help-page section-surface">
      <PageHeader />
      <section className="valentina-help-hero">
        <MessageCircle size={28} />
        <h1>PRECISA DE AJUDA?</h1>
        <p>Ficou com alguma dúvida sobre a compra do seu presente? Fale com a gente direto pelo WhatsApp que respondemos rapidinho.</p>
        <a
          className="valentina-help-whatsapp"
          href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`}
          target="_blank"
          rel="noreferrer"
        >
          Falar no WhatsApp
        </a>
      </section>
    </main>
  );
}
